<template>
  <ion-page class="mixture">
    <common-background
      :title="'混组检查  ' + mixStep"
      router-type="modal"
      @router-back="onConfirmClose"
    >
      <template #default>
        <div v-show="!showButtons" id="mixturePage" class="mixture_page">
          <div v-if="dataList?.length" class="word-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row justify-between"
              @click="onShowParaphrase(index, item, $event)"
            >
              <div class="item-word flex-row align-center flex-wrap">
                <span
                  v-show="!item.showParaphrase"
                  class="word-style switch-font-size flex-row align-center mr-5"
                >
                  {{ item.word }}
                </span>
                <div
                  v-show="item.showParaphrase"
                  class="cnword flex-row word-style gray-color flex-wrap"
                >
                  <span class="english-word switch-font-size">{{ item.word }}</span
                  ><span>{{ item.paraphrase }}</span>
                </div>
              </div>
              <div class="item-icon flex-row align-center">
                <img
                  v-if="item.audioIconShow || showOneButton"
                  src="@/assets/teacher_index/version5/teacher_button.png"
                  class="img-icon cursor-pointer mr-4"
                  @click.stop="
                    playUniversalFormulaAudio(item.word, item.paraphrase, 50 * speedRate)
                  "
                />
                <div
                  v-if="showOneButton"
                  class="inner-box flex-row align-center"
                  @click.stop="onSelect2(index, item)"
                >
                  <img
                    class="test-icon cursor-pointer"
                    src="@/assets/teacher_index/version5/scissors_right.svg"
                    alt=""
                  />
                </div>

                <div v-if="!showOneButton" class="inner-box" @click.stop="onYes2(index, item)">
                  <img
                    class="test-icon cursor-pointer mr-4"
                    src="@/assets/teacher_index/version5/scissors_right.svg"
                    alt=""
                  />
                </div>

                <div v-if="!showOneButton" class="inner-box" @click.stop="onNot(index, item)">
                  <img
                    class="test-icon cursor-pointer"
                    src="@/assets/teacher_index/version5/scissors_mistake.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mixture-empty">
            <!--            <div class="mixture-empty-tip" :class="{'onlyNotNumClass': selectNotNum && !selectYesNum}">-->
            <!--              <div class="mixture-empty-tip__title">点击继续</div>-->
            <!--              <img class="mixture-empty-tip__img" :src="getBrandImageUrl('speed/green_down_icon.png')" alt="点击继续">-->
            <!--            </div>-->
            <!--            <div v-show="selectNotNum" class="mixture-empty-tip notNumClass">-->
            <!--              <div class="mixture-empty-tip__title">点击继续</div>-->
            <!--              <img class="mixture-empty-tip__img" :src="getBrandImageUrl('speed/red_down_icon.png')" alt="点击继续">-->
            <!--            </div>-->
          </div>
        </div>
        <div
          v-show="showButtons"
          class="mixture_page encourage-padding flex-column justify-between"
        >
          <div class="emoji flex-column align-center">
            <img :src="getBrandImageUrl('speed/encourage_bg.png')" alt="" />
          </div>
          <div class="flex-column">
            <ion-button class="button-outline mb-3" shape="round" @click="onReCheck"
              >重新检查
            </ion-button>
            <ion-button
              v-show="!isEnd && !isOver"
              class="green_bg mb-3"
              shape="round"
              @click="backSign"
              >下一组
            </ion-button>
            <ion-button
              v-show="isEnd && !isOver"
              class="green_bg mb-3"
              shape="round"
              @click="onMixtureAll(step)"
              >混组全部
            </ion-button>
            <ion-button v-show="isOver" class="green_bg mb-3" shape="round" @click="openAfterTest"
              >训后检测
            </ion-button>
          </div>
        </div>
      </template>
      <template #rightTitle>
        <switch-font-size />
        <speed-switch />
      </template>
    </common-background>
    <div v-show="!showButtons" class="mixture_bottom">
      <div class="mixture_bottom-content flex-row justify-evenly align-center">
        <div v-show="showOneButton" class="mixture_box" @click="onRestore">
          <img
            v-show="selectNum == 0"
            src="@/assets/teacher_index/version5/empty_green_box.svg"
            alt=""
          />
          <img
            v-show="selectNum != 0"
            src="@/assets/teacher_index/version5/fill_green_box.svg"
            alt=""
          />
          <span class="box-text true-text">{{ selectNum }}</span>
        </div>
        <div v-show="!showOneButton && selectYesNum == 0" class="mixture_box" @click="onYesRestore">
          <img src="@/assets/teacher_index/version5/empty_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div v-show="!showOneButton && selectYesNum != 0" class="mixture_box" @click="onYesRestore">
          <img src="@/assets/teacher_index/version5/fill_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div v-show="!showOneButton && selectNotNum == 0" class="mixture_box" @click="onNotRestore">
          <img src="@/assets/teacher_index/version5/empty_red_box.svg" alt="" />
          <span class="box-text false-text">{{ selectNotNum }}</span>
        </div>
        <div v-show="!showOneButton && selectNotNum != 0" class="mixture_box" @click="onNotRestore">
          <img src="@/assets/teacher_index/version5/fill_red_box.svg" alt="" />
          <span class="box-text false-text">{{ selectNotNum }}</span>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { IonButton, IonPage, modalController } from "@ionic/vue"

import {
  arrowBackCircle,
  arrowForwardCircle,
  arrowUndo,
  checkmarkCircle,
  chevronBackOutline,
  closeCircle,
  gitCompare,
  reorderFour,
} from "ionicons/icons"

import AfterTestPage from "@/views/speed/AfterTest"

import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import CommonBackground from "@/components/CommonBackground.vue"
import { playUniversalFormulaAudio } from "@/js/commonMethod"
import SpeedSwitch from "@/components/speedSwitch.vue"
import { useStorage } from "@vueuse/core"
import SwitchFontSize from "@/views/other/SwitchFontSize.vue"

const mixStepMap = ["0", "1", "1,2", "1,2,3", "4", "4,5", "4,5,6", "7", "7,8", "7,8,9"]
const speedRate = useStorage("xf-speed", 1, localStorage)
export default {
  name: "SpeedMixture",
  components: {
    SwitchFontSize,
    SpeedSwitch,
    CommonBackground,
    IonPage,
    IonButton,
  },
  props: ["studentId", "step"],
  setup() {
    return {
      checkmarkCircle,
      closeCircle,
      chevronBackOutline,
      gitCompare,
      arrowUndo,
      reorderFour,
      arrowBackCircle,
      arrowForwardCircle,
      speedRate,
    }
  },

  data() {
    return {
      dataList: [],
      showButtons: false, //剪纸盒步骤
      showOneButton: true, //显示一个操作按钮
      isEnd: false, //控制"混组全部"按钮显示
      isOver: false, //控制"全部结束"按钮显示
      mixStep: undefined,
      selectItems: [],
      selectYesItems: [],
      selectNotItems: [],
      selectNum: 0,
      selectYesNum: 0,
      selectNotNum: 0,
      brandImages: BRAND_IMAGES,
    }
  },

  mounted() {
    this.initQuery()
  },

  methods: {
    playUniversalFormulaAudio,
    getBrandImageUrl,
    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.initQuery(RefreshAnimationEvent)
    },

    backSign() {
      modalController.dismiss({ status: "TO_SIGN" })
    },

    //混组检查
    async openAfterTest() {
      const modal = await modalController.create({
        component: AfterTestPage,
        componentProps: {
          studentId: this.studentId,
          showCloseButton: false,
          notForce: true,
        },
        cssClass: "modal_controller_class",
        backdropDismiss: false, // 禁止点击背景关闭
        keyboardClose: false, // 禁止ESC按键关闭
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if (data) {
        await modalController.dismiss({ ...data })
      }
    },

    //重置数据
    reset() {
      this.showButtons = false //剪纸盒步骤
      this.showOneButton = true //混组检查第一步
      this.isEnd = false //显示终点按钮
      this.selectItems = []
      this.selectYesItems = []
      this.selectNotItems = []
      this.selectNum = 0
      this.selectYesNum = 0
      this.selectNotNum = 0
    },

    //重新检测
    onReCheck() {
      if (this.selectYesItems.length > 0 && this.dataList.length == 0) {
        for (let i = 0; i < this.selectYesItems.length; i++) {
          this.selectYesItems[i]["audioIconShow"] = false
          this.dataList.push(this.selectYesItems[i])
        }
        this.showButtons = false //剪纸盒步骤
        this.selectItems = []
        this.selectYesItems = []
        this.selectNotItems = []
        this.selectNum = 0
        this.selectYesNum = 0
        this.selectNotNum = 0
      }
    },

    //还原中间盒子
    onRestore() {
      if (this.selectItems.length > 0 && this.dataList.length == 0) {
        this.showOneButton = false
        for (let i = 0; i < this.selectItems.length; i++) {
          this.dataList.push(this.selectItems[i])
        }
        this.selectItems = []
        this.selectNum = 0
      }
    },

    //还原回的盒子
    onYesRestore() {
      if (this.selectYesItems.length > 0) {
        this.dataList.push(this.selectYesItems.pop())
        this.selectYesNum = this.selectYesItems.length
      }
    },

    //还原不会的盒子
    onNotRestore() {
      if (this.selectNotItems.length > 0) {
        this.selectNotItems = this.selectNotItems.map((item) => {
          item["audioIconShow"] = true
          item["clickStep"] = 1
          return item
        })
        this.dataList = this.dataList.concat(this.selectNotItems)
        this.selectNotItems = []
        this.selectNotNum = this.selectNotItems.length
      }
    },

    //加入中间盒子
    onSelect(index, item) {
      if (item.showParaphrase) {
        item.showParaphrase = false
        item["audioIconShow"] = false
        this.selectItems.push(item)
        this.selectNum++
        this.dataList.splice(index, 1)
        this.audio(this.voice_path + "right.mp3")
      } else {
        item.showParaphrase = true
        item["playbackRate"] = speedRate.value
        //this.playSound(item.word);
        this.playSoundTemp(item)
      }
    },

    //自动带读模式，第一遍学习每个单词需要点击三次
    //第一遍打钩  重写，2024-02-27
    //点击3次，第一次只发音，第二次显示中英文，第三次消失
    onSelect2(index, item) {
      //第一遍只发音
      if (item.clickStep == 1) {
        item["playbackRate"] = speedRate.value
        this.playSoundTemp(item)
        item.showParaphrase = true
        item.clickStep = 3
      }
      //第三遍消失
      else if (item.clickStep == 3) {
        item.showParaphrase = false
        item.clickStep = 1
        item["audioIconShow"] = false
        this.selectItems.push(item)
        this.selectNum++
        this.dataList.splice(index, 1)
        this.audio(this.voice_path + "right.mp3")
      }
    },

    //加入会的盒子
    onYes(index, item) {
      item.showParaphrase = false
      this.selectYesItems.push(item)
      this.selectYesNum = this.selectYesItems.length
      this.dataList.splice(index, 1)
      this.audio(this.voice_path + "right.mp3")
      if (this.dataList.length == 0 && this.selectNotItems.length == 0) {
        this.showButtons = true //混组检查
      }
    },

    onYes2(index, item) {
      //第一遍只发音
      if (item.clickStep == 1) {
        // item["playbackRate"] = speedRate.value;
        // this.playSoundTemp(item);
        item.showParaphrase = false
        item.clickStep = 1
        this.selectYesItems.push(item)
        this.selectYesNum = this.selectYesItems.length
        this.dataList.splice(index, 1)
        this.audio(this.voice_path + "right.mp3")
        if (this.dataList.length == 0 && this.selectNotItems.length == 0) {
          this.showButtons = true //混组检查
        }
      }
    },

    //加入不会的盒子
    onNot(index, item) {
      item.showParaphrase = false
      this.selectNotItems.push(item)
      this.selectNotNum = this.selectNotItems.length
      this.dataList.splice(index, 1)
      this.audio(this.voice_path + "err.mp3")
    },

    //控制释义显示
    onShowParaphrase(index, item) {
      //this.playSound(item.word);
      item["playbackRate"] = speedRate.value
      this.playSoundTemp(item)
      for (let i = 0; i < this.dataList.length; i++) {
        if (index == i) {
          this.dataList[i].showParaphrase = !item.showParaphrase
        } else {
          this.dataList[i].showParaphrase = false
        }
      }
    },

    //查询出需要练习的词汇
    queryVocabulary(step, RefreshAnimationEvent) {
      this.ajax
        .get("/vocabulary/queryMixtureWords?studentId=" + this.studentId + "&pageNum=" + step)
        .then((res) => {
          if (res.data.success) {
            this.isEnd = res.data.isEnd
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].status = 1
              res.data.list[i].showParaphrase = false
              res.data.list[i].clickStep = 1
            }

            //打乱顺序
            res.data.list.sort(function () {
              return 0.5 - Math.random()
            })

            this.dataList = res.data.list

            if (RefreshAnimationEvent) {
              RefreshAnimationEvent.target.complete()
            }
          }
        })
    },

    //全部混组
    mixtureAll(RefreshAnimationEvent) {
      this.ajax.get("/vocabulary/queryMixtureAllWords?studentId=" + this.studentId).then((res) => {
        if (res.data.success) {
          this.isOver = true
          this.reset()
          for (let i = 0; i < res.data.list.length; i++) {
            res.data.list[i].status = 1
            res.data.list[i].showParaphrase = false
            res.data.list[i].clickStep = 1
          }

          //打乱顺序
          res.data.list.sort(function () {
            return 0.5 - Math.random()
          })

          this.dataList = res.data.list

          if (RefreshAnimationEvent) {
            RefreshAnimationEvent.target.complete()
          }
        }
      })
    },

    //全部混组
    onMixtureAll() {
      this.mixStep = "全部混组"
      this.mixtureAll()
    }, //---

    initQuery(ev) {
      const iStep = parseInt(this.step)
      if (iStep == 10) {
        this.mixStep = "全部混组"
        this.mixtureAll(ev)
      } else {
        this.mixStep = "第" + mixStepMap[iStep] + "组"
        this.queryVocabulary(iStep, ev)
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/styles/variables.less";

.mixture {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 0 5vh;
  user-select: none;
  -webkit-user-select: none;

  &_page {
    width: 100%;
    height: 92%;
    overflow: auto;
    padding: 0.8rem;
    background-color: #ffffff;

    .word-list {
      &_item {
        padding: 4vw;
        background-color: var(--page-bg-color);
        border-radius: 2vw;
        margin-bottom: 5vw;
        border: 1px solid transparent;
        position: relative;

        .item-word {
          flex: 1;
          width: 70%;
        }

        .item-icon {
          min-width: 25%;
          flex-shrink: 0;
        }

        .english-word {
          margin-right: 1rem;
        }

        .left-line {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 0.8vw;
          height: 60%;
          border-radius: 0.5vw;
          background-color: var(--green-bg-color);
        }

        .word-style {
          max-width: 100%;
          font-size: var(--font-size);
          word-break: break-all;
          align-items: baseline;
        }

        .test-icon {
          width: 2rem;
          height: 2rem;
          flex-shrink: 0;
          transition: transform 0.1s ease-in-out;

          &:active {
            transform: scaleY(0);
            transition: transform 0.1s ease-in-out;
          }
        }

        .img-icon {
          width: 2rem;
          height: 2rem;
          margin-left: 3vw;
        }
      }

      .item-checked {
        border: 1px solid var(--green-bg-color);
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }

    ion-button::part(native) {
      box-sizing: content-box;
      padding: 1vw 0;
    }
  }

  &-empty {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    &-tip {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 8vh;

      &__title {
        color: #868f9e;
        font-size: 1rem;
        margin-bottom: 10px;
      }

      &__img {
        width: 25vw;
      }
    }

    .onlyNotNumClass {
      opacity: 0;
    }

    .notNumClass {
      margin-left: 10vw;
    }
  }

  .encourage-padding {
    width: 100%;
    height: 100%;
    padding: 0 5vw;

    .emoji {
      width: 90%;
      margin: 0 auto;
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7rem;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);

    &-content {
      height: 80%;
      padding: 2vh 3vw 0;
    }
  }

  &_box {
    position: relative;
    //width: 8vh;

    img {
      width: 4rem;
    }

    .box-text {
      position: absolute;
      left: 50%;
      top: 16%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      font-weight: 600;
    }

    .true-text {
      color: #0bbb7d;
    }

    .false-text {
      color: #ff3142;
    }
  }

  .inner-box {
    display: flex;
  }
}
</style>
